import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { chatStages } from '../models/ChatStages'

// export const serverURL = "https://chatitout-server.onrender.com";
// export const serverURL = "http://127.0.0.1:5001";
export const serverURL = "https://chatitout.jibc.ca";

const getStageNum = (currStage) => {
  const stageIndex = chatStages.indexOf(currStage);
  if (stageIndex === -1) {
    console.error("something wrong with the getStageNum");
    return -1; 
  }
  return stageIndex + 1;
};

export const getAIResponse = createAsyncThunk('openAI/getAIResponse', async (userInput, { getState, rejectWithValue }) => {
  const currChatMessages = getState().currChat.messages
  const sessionId = getState().currChat.sessionId
  const currChatStage = getState().currChat.stage
  const context = Object.values(currChatMessages).flat()
  const input = { sessionId: sessionId, context: context, newMsg: userInput, stage: getStageNum(currChatStage) };

  try {
      const resp = await axios.post(`${serverURL}/api/home/chat`, input, {
          headers: {
              'Content-Type': 'application/json',
          }
      });
      return resp.data;
  } catch (err) {
      console.log(err);
      return rejectWithValue("getAIResponse encountered error")
  }
})

export const deleteSessionInBE = createAsyncThunk('be/deleteSessionInBE', async (session_id) => {
  try {
      const resp = await axios.delete(`${serverURL}/api/chat/${session_id}`);
      console.log("see response data: ", resp.data)
  } catch (err) {
      console.log(err);
      return "An error occured. Please try again later."
  }
}) 

export const getSummary = createAsyncThunk('openAI/getSummary', async (_, { getState }) => {
  const sessionId = getState().currChat.sessionId
  const currChatStage = getState().currChat.stage
  const input = { sessionId, stage: getStageNum(currChatStage) }
  try {
    const resp = await axios.post(`${serverURL}/api/chat/summary`, input, {
      headers: {
          'Content-Type': 'application/json',
      }
  })
    console.log("see response data: ", resp.data)
    return resp.data;
  } catch (err) {
    console.log(err);
    return "An error occured. Please try again later."
  }
})

export const recenterConversation = createAsyncThunk('openAI/recenterConversation', async (params, { getState }) => {
  const uncheckedItems = params.map(item => item.text)
  const sessionId = getState().currChat.sessionId
  const currChatStage = getState().currChat.stage
  const input = { sessionId, stage: getStageNum(currChatStage), uncheckedItems }
  try {
    const resp = await axios.post(`${serverURL}/api/chat/recenterConversation`, input, {
      headers: {
          'Content-Type': 'application/json',
      }
  })
    console.log("see response data: ", resp)
  } catch (err) {
    console.log(err);
    return "An error occured. Please try again later."
  }
})